import { ColorEnum } from '@/constants/color'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'

export const mainColors = {
    [ButtonStateEnum.Default]: {
        primary: ColorEnum.BRICK_600,
        secondary: ColorEnum.BLUE_500,
    },
    [ButtonStateEnum.Hovered]: {
        primary: ColorEnum.BRICK_700,
        secondary: ColorEnum.Blue600,
    },
    [ButtonStateEnum.Pressed]: {
        primary: ColorEnum.BRICK_700,
        secondary: ColorEnum.Blue600,
    },
    [ButtonStateEnum.Disabled]: {
        primary: ColorEnum.BRICK_200,
        secondary: ColorEnum.Blue200,
    },
} as const

export const defaultInteractiveBackgroundColors = {
    primary: ColorEnum.BRICK_200,
    secondary: ColorEnum.Blue100,
} as const

export const outlineInteractiveBackgroundColors = {
    primary: ColorEnum.Brick300,
    secondary: ColorEnum.Blue100,
} as const

export const shadowColors = {
    primary: ColorEnum.BRICK_600,
    secondary: ColorEnum.Blue600,
} as const
